import React, { useState, useEffect, forwardRef } from "react";
import FullCalendar, { constrainPoint } from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { ko } from "date-fns/locale";
import {
    Box, Select, MenuItem, FormControl, InputLabel, Dialog,
    AppBar, Toolbar, IconButton,
    Typography, Button, alertTitleClasses
} from "@mui/material";
import CenterSelect from "./CenterSelect";
import { configState, loginState } from "../lib/State";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import moment from "moment";
import add_comma from "../lib/add_comma";
import remove_comma from "../lib/remove_comma";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import pr from "../lib/pr";
import styled from "@emotion/styled";
import { brown, green, blue, orange, purple, red } from '@mui/material/colors';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const token = get_token();
const cid = get_cid();

const Container = styled(Box)`
    .MuiTypography-body1 { font-size: 14px; }
`;

export default function ReportCouponDialogList(props) {

    const { dt, sdate, edate, cid, tcid, login } = props;
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const load_data = async () => {
        let result = await axios.post(configState.api + '/chart/report_coupon_list', {
            token: token,
            mcd: login.mcd,
            cid: cid,
            tcid: tcid,
            sdate: sdate,
            edate: edate,
            level: login.level,
        });
        if (result.data.success === 1) {
            setRows(result.data.rows);
            console.table(rows);
        }
    }

    useEffect(() => {
        load_data();
    }, []);

    // paging
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return <Container p={1}>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow sx={{ background: brown[200] }}>
                        <TableCell sx={{ width: 120 }}><Typography>수업일</Typography></TableCell>
                        <TableCell sx={{ width: 120 }}><Typography>수업시간</Typography></TableCell>
                        <TableCell sx={{ width: 180 }}><Typography>쿠폰명</Typography></TableCell>
                        <TableCell sx={{ width: 120 }}><Typography>쿠폰가격</Typography></TableCell>
                        <TableCell sx={{ width: 120 }}><Typography>강사명</Typography></TableCell>
                        <TableCell sx={{ width: 120 }}><Typography>고객명</Typography></TableCell>
                        <TableCell><Typography>센터명</Typography></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((i, k) => {
                            return <TableRow key={k} sx={{ height: 30 }}>
                                <TableCell><Typography>{i.class_date}</Typography></TableCell>
                                <TableCell><Typography>{i.class_hour}</Typography></TableCell>
                                <TableCell><Typography>{i.pname}</Typography></TableCell>
                                <TableCell><Typography>{add_comma(i.amount)}</Typography></TableCell>
                                <TableCell><Typography>{i.tname}</Typography></TableCell>
                                <TableCell><Typography>{i.uname}</Typography></TableCell>
                                <TableCell><Typography>{i.cname}</Typography></TableCell>
                            </TableRow>
                        })}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

        </TableContainer>
    </Container>
}